var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickOutSide.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "filter-dialog" }, [
        _c("div", { staticClass: "filter-header" }, [
          _c("span", { staticClass: "filter-header-title" }, [
            _vm._v(_vm._s(_vm.$t("homePage.novelList.filter.dialogTitle"))),
          ]),
          _c(
            "button",
            {
              staticClass: "filter-close-button",
              on: { click: _vm.onClickOutSide },
            },
            [_c("span", [_vm._v("×")])]
          ),
        ]),
        _c("div", { staticClass: "filter-body" }, [
          _c("div", { staticClass: "filter-section" }, [
            _c("h4", { staticClass: "filter-section-title" }, [
              _vm._v(_vm._s(_vm.$t("homePage.novelList.filter.workStatus"))),
            ]),
            _c(
              "div",
              { staticClass: "filter-chips" },
              _vm._l(_vm.workStatusOptions, function (option) {
                return _c(
                  "button",
                  {
                    key: option.id,
                    staticClass: "filter-chip",
                    class: {
                      active: _vm.selectedWorkStatusIds.includes(option.id),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toggleWorkStatus(option.id)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(option.name) + " ")]
                )
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "filter-section" }, [
            _c("h4", { staticClass: "filter-section-title" }, [
              _vm._v(_vm._s(_vm.$t("homePage.novelList.filter.genre"))),
            ]),
            _c(
              "div",
              { staticClass: "filter-chips" },
              _vm._l(_vm.genreOptions, function (option) {
                return _c(
                  "button",
                  {
                    key: option.id,
                    staticClass: "filter-chip",
                    class: { active: _vm.selectedGenreIds.includes(option.id) },
                    on: {
                      click: function ($event) {
                        return _vm.toggleGenre(option.id)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(option.name) + " ")]
                )
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "filter-section" }, [
            _c("h4", { staticClass: "filter-section-title" }, [
              _vm._v(_vm._s(_vm.$t("homePage.novelList.filter.category"))),
            ]),
            _c(
              "div",
              { staticClass: "filter-chips" },
              _vm._l(_vm.categoryOptions, function (option) {
                return _c(
                  "button",
                  {
                    key: option.id,
                    staticClass: "filter-chip",
                    class: {
                      active: _vm.selectedCategoryIds.includes(option.id),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toggleCategory(option.id)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(option.name) + " ")]
                )
              }),
              0
            ),
          ]),
          _vm.groupOptions.length > 0
            ? _c("div", { staticClass: "filter-section" }, [
                _c("h4", { staticClass: "filter-section-title" }, [
                  _vm._v(_vm._s(_vm.$t("homePage.novelList.filter.group"))),
                ]),
                _c(
                  "div",
                  { staticClass: "filter-chips" },
                  _vm._l(_vm.groupOptions, function (option) {
                    return _c(
                      "button",
                      {
                        key: option.groupId,
                        staticClass: "filter-chip",
                        class: {
                          active: _vm.selectedGroupIds.includes(option.groupId),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggleGroup(option.groupId)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(option.name) + " ")]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "filter-actions" }, [
          _c(
            "button",
            { staticClass: "filter-apply-button", on: { click: _vm.onApply } },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("homePage.novelList.filter.apply")) + " "
              ),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "filter-cancel-button",
              on: { click: _vm.onCancel },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }